<section class="wraper-sub">
  <div class="unpaid-order-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Un-Paid Orders</h1>

        <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection">
            <span>$ {{ leads.totalPay | number }}</span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="leads.totalPay"></i>
          </p>

          <div class="year-selection-m" *ngIf="leads.totalPay">
            <!-- Modal -->
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Total : $ {{ leads.totalPay | number }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p">
                      <li *ngFor="let paymentPart of leads.dispositionTotal" [title]="totalPaymentSearch(paymentPart.unpaid_agent_status, despositionArray)">
                        <label>{{ totalPaymentSearch(paymentPart.unpaid_agent_status, despositionArray) }}</label>
                        <span>$ {{ paymentPart.totpay | number }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" (change)="rerender()" [(ngModel)]="searchParams.emailId" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                    fill="#1C212D" />
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D" />
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D" />
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D" />
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D" />
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D" />
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D" />
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D" />
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D" />
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D" />
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D" />
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D" />
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D" />
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D" />
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D" />
              </svg>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                  [items]="despositionArray"
                  bindLabel="name"
                  bindValue="value"
                  placeholder="Order Status"
                  [(ngModel)]="searchParams.disposition"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  (change)="rerender()"
                  >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter" *ngIf="!isMyTab">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="agents"
                bindLabel="name"
                multiple="true"
                bindValue="id"
                placeholder="Agent Name"
                [(ngModel)]="searchParams.agent_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="true"
                [clearable]="true"
                [closeOnSelect]="false"
                (change)="selectAll()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <input [checked]="searchParams.agent_id.indexOf(item.id) > -1" type="checkbox">
                  {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                    fill="#1C212D" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client info</th>
              <th>Price / No. of Pages</th>
              <th>Due Date</th>
              <th>Disposition</th>
              <th>Agent</th>
              <th>Q/A Comments</th>
              <th>Comments</th>
            </tr>
          </thead>

          <!-- QA Portal -->
          <ng-container *ngIf="activeUser.Portal_QA && leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>
                <td>
                  <p *ngIf="lead.date" class="time-done">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <div class="pos-rel" *ngIf="lead.many_order">
                    <a href="javascript:;" (click)="showManyOrder(lead, indx)">
                      {{ lead.name }}
                    </a>
                    
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'many_order_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog resize" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title left-align" id="exampleModalLabel1">
                              Orders Detail
                            </h5>
                            
                          </div>
                          <div class="modal-content">
                            <div class="modal-body text-start">
                              <div class="row parent">
                                <!-- Paid Orders Section -->
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col"><b>Customer Since:</b></div>
                                    <div class="col">{{ many_orders_detail.first_paid_order_date | date: 'dd MMM yyyy' }}</div>
                                  </div>
                                  <!-- <div class="row">
                                    <div class="col"><b>Orders Till Date:</b></div>
                                    <div class="col">{{ many_orders_detail.total_paid_orders }}</div>
                                  </div>
                                  <div class="row">
                                    <div class="col"><b>Value of Orders:</b></div>
                                    <div class="col">${{ many_orders_detail.paid_orders_value.toFixed(2) }}</div>
                                  </div> -->
                                  <div class="row">
                                    <div class="col"><b>Last Order Date:</b></div>
                                    <div class="col">{{ many_orders_detail.last_paid_order_date | date: 'dd MMM yyyy' }}</div>
                                  </div>
                                 </div>
                      
                                <!-- Unpaid Orders Section -->
                                <!-- <div class="col-12">
                                  <h5>Unpaid</h5>
                                  <p><b>Total Orders Till Date:</b> {{ many_orders_detail.total_unpaid_orders }}</p>
                                  <p><b>Value of Orders:</b> ${{ many_orders_detail.unpaid_orders_value.toFixed(2) }}</p>
                                  <p><b>First Order Date:</b> {{ many_orders_detail.first_unpaid_order_date | date: 'dd MMM yyyy' }}</p>
                                  <p><b>Last Order Date:</b> {{ many_orders_detail.last_unpaid_order_date | date: 'dd MMM yyyy' }}</p>
                                </div> -->
                              </div>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                  <p *ngIf="!lead.many_order">{{ lead.name }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <p class="price-td" [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>
                <td>
                  <p *ngIf="lead.delivery_date == '0000-00-00 00:00'">-</p>
                  <ng-container *ngIf="lead.delivery_date != '0000-00-00 00:00'">
                    <p>{{ lead.delivery_date | date }}</p>
                    <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <p class="time-left">{{ lead.time_remaining }}</p>
                </td>

                <td>
                  <p class="roundedShape">
                    <span [ngClass]="{'validBox': despositionArray.value == 0, 'disabledBox inValidBox': despositionArray.value != 0 }">
                      {{ showDisposition(lead.status,despositionArray) }}
                    </span>
                  </p>
                </td>

                <td>
                  <span class="time-done">{{ lead.agent }}</span>
                </td>

                <td>

                    <div class="pos-rel">
                      <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingComments"></i>

                        <a *ngIf="!lead.loadingComments" href="javascript:;" [ngClass]="{'iconGrey': !lead.qa_comments}" (click)="showComments(lead,indx, 'QA-Comments')">
                          <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="qaloader != lead.id">
                            <path d="M5.04184 5.45456H15.1252C15.3785 5.45456 15.5835 5.25125 15.5835 5C15.5835 4.74875 15.3785 4.54544 15.1252 4.54544H5.04184C4.7885 4.54544 4.5835 4.74875 4.5835 5C4.58354 5.25129 4.78854 5.45456 5.04184 5.45456Z"
                                [attr.fill]="lead.qa_comments ? '#00A5DC' : 'grey'" />
                            <path d="M10.5418 10H5.04184C4.7885 10 4.5835 10.2033 4.5835 10.4546C4.5835 10.7058 4.7885 10.9091 5.04184 10.9091H10.5418C10.7952 10.9091 11.0002 10.7058 11.0002 10.4546C11.0002 10.2033 10.7952 10 10.5418 10Z" [attr.fill]="lead.qa_comments ? '#00A5DC' : 'grey'" />
                            <path
                                d="M20.2455 1.81819C20.2189 1.81819 20.1932 1.8248 20.1667 1.82603V1.81819C20.1667 0.815453 19.344 0 18.3333 0H1.83335C0.82268 0 0 0.815453 0 1.81819V19.5454C0 19.7292 0.111891 19.8952 0.282863 19.9654C0.339281 19.9889 0.399223 20 0.458305 20C0.577371 20 0.694633 19.9538 0.782375 19.8668L5.23145 15.4545H18.3333C19.344 15.4545 20.1667 14.6391 20.1667 13.6363V6.09707L21.4862 4.7887C21.4862 4.7887 21.4862 4.7887 21.4862 4.78827C21.8129 4.46424 22 4.0159 22 3.55823C22 2.59858 21.2132 1.81819 20.2455 1.81819ZM19.25 13.6363C19.25 14.1375 18.8391 14.5454 18.3333 14.5454H5.04165C4.91992 14.5454 4.80352 14.5934 4.71758 14.6786L0.916652 18.4481V1.81819C0.916652 1.31706 1.32756 0.909118 1.8333 0.909118H18.3333C18.8391 0.909118 19.25 1.31706 19.25 1.81819V2.12868C19.163 2.18799 19.0798 2.25324 19.0047 2.32777L14.0178 7.27273H5.04165C4.78831 7.27273 4.5833 7.47604 4.5833 7.72729C4.5833 7.97854 4.78831 8.18185 5.04165 8.18185H13.2824L12.8423 10.3654C12.8119 10.5145 12.8593 10.6686 12.9676 10.776C13.0545 10.8621 13.1717 10.9091 13.2917 10.9091C13.3213 10.9091 13.3517 10.906 13.3812 10.9003L15.672 10.4457C15.7615 10.4279 15.843 10.3849 15.9065 10.3214L19.25 7.00606V13.6363ZM15.3569 9.58141L13.8762 9.87527L14.1726 8.4051L18.3331 4.27891L19.5185 5.4545L15.3569 9.58141ZM20.838 4.14596L20.1667 4.8118L18.9812 3.63613L19.6528 2.97008C19.8085 2.81603 20.0243 2.72727 20.2454 2.72727C20.7073 2.72727 21.0833 3.10014 21.0833 3.55823C21.0833 3.77663 20.9938 3.99106 20.838 4.14596Z"
                                [attr.fill]="lead.qa_comments ? '#00A5DC' : 'grey'" />
                          </svg>
                          <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="qaloader == lead.id"></i>
                        </a>
                        <div class="notesModal mainModal qa-lead">
                          <div class="modal fade" [id]="'notesModal' + indx" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                              <div class="modal-header">
                                <h5 class="modal-title text-left">Q/A Comments</h5>
                              </div>
                              <div class="modal-content">
                                <div class="modal-body">
                                  <form [formGroup]="addCommentForm">
                                    <div class="formItem shadowed w-100">
                                      <textarea [(ngModel)]="notes" formControlName="comment" [ngClass]="{ 'is-invalid': submitted && f.comment.errors }" placeholder="Add a new comment by typing here."></textarea>
                                    </div>
                                    <div class="formBtns text-right">
                                      <button class="pBtn" (click)="addNotes(lead, indx, 'QA-Comments')">Add
                                        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loading"></i>
                                      </button>
                                    </div>
                                  </form>
                                  <h5 class="modal-title text-left" *ngIf="qaComments && qaComments.length > 0">All Previous Comments </h5>
                                  <ul class="allNotes comment-box" *ngIf="qaComments">
                                    <li *ngFor="let comment of qaComments">
                                      <label>{{ agentSearch(comment.user_id, qa) }}</label>
                                      <p class="p-0 text-left">{{ comment.notes }}</p>
                                      <span class="date-comment">{{ comment.date | customDatePipe: 'shortTime'}}</span>
                                    </li>
                                </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </td>

                <td>
                  <div class="pos-rel">
                    
                    <div *ngIf="!lead.showComments">-N/A-</div>
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingCommentsAgent"></i>
                    <a *ngIf="!lead.loadingCommentsAgent" href="javascript:;" (click)="showComments(lead,indx,'Unpaid-Comments')">
                      <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="loader != lead.id">
                        <path
                            d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z"
                            [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                        <path
                            d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z"
                            [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                        <path
                            d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z"
                            [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                      </svg>
                      <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loader == lead.id"></i>
                    </a>
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'comment_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title w-100" id="exampleModalLabel1" *ngIf="unpaidComments.length > 0">Agent Comments</h5>

                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="comments-sub w-100" *ngIf="unpaidComments.length > 0">
                                <ng-container *ngFor="let comment of unpaidComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>

        </table>
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
    <div class="floatingAlert" *ngIf="floatingAlert">
        <button type="button" class="close" (click)="closeFloatingAlert();">
          <i class="fa fa-times"></i>
        </button>
        <p>{{ leads.alertMessage }}</p>
    </div>
</ng-container>
<!-- floating alert ends -->
